export default __webpack_public_path__ + "static/media/no-permission.319199870e05a04a848723a558a972fe.svg";